module.exports = __webpack_public_path__ + "img/art_4_1.738fb84e.png";